import { APIsEndPoints } from './../utilities/apis.endpoints';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse,HttpHeaders,HttpParams } from '@angular/common/http';


import { Observable } from 'rxjs';
import { from } from 'rxjs';
import {map, filter } from 'rxjs/operators';
import {firstBy} from 'thenby';
import { UserModel } from '../models/user.model';
import { Options } from 'selenium-webdriver/firefox';
import { SettingsService } from './settings.service';


@Injectable({
  providedIn: 'root'
})
export class CrewDataService {

  url = APIsEndPoints.BASE_URL;
  url_v2 = APIsEndPoints.BASE_URL_V2;
  contactEmailArray = [];
  // private crew: Observable<UserModel[]>; 
  // private crew: Observable<Object[]>; 

  constructor(private http: HttpClient,private settingsService: SettingsService,) { 
    //this.getSubmitterDetailSetting();
  }

  getAllCrew(){
    console.log('service');
    // let crew = this.http.get(`${this.url}/users`);
    // crew = crew.pipe(map(users => users.filter(userData => userData.roles.indexOf('crew') > -1)));
    // return this.http.get(`${this.url}/users`).map(projects => projects.filter(proj => proj.name === name));
    // crew.map(crew.filter(item => item.roles.indexOf('crew')>-1)))
    // let crewList = crew.pipe(filter(crewData => crewData.))
    return this.http.get(`${this.url}/users`);
  }

  addCrew(crew: any){
    console.log('crew model',crew)
     return this.http.post(`${this.url}/users`, crew);
  }

  bulkUploadUsers(usersJson: any){
    console.log('service file ', usersJson);
    return this.http.post(`${this.url}/users/addBulkUsers`,usersJson);
  }


  getSubmitterDetailSetting(){
    this.settingsService.getSubmitterDetailViewStatus().subscribe((data : any) => {
      console.log('Settings',data);
      if(data){
        this.contactEmailArray = data.submitterEmailAddressArray;
      }
    })
  }


  sendEmailToUser(filename: any,attachment: any){
    let usersEmail = this.settingsService.getEmailAddress();
    console.log('usersEmail ',usersEmail);
    let index = 0;
    if(index < 1){
      console.log('data list self ',JSON.parse(localStorage.getItem('userProfile')));
      let userObject = JSON.parse(localStorage.getItem('userProfile'));
      let userEmailAddress = userObject.user.email;
      let recieverList: any = usersEmail;
      recieverList.push(userEmailAddress);
      //console.log('filename ',filename);
      //console.log('attachment ',attachment);
      console.log('recieverList ',recieverList);
      let filedata = {files: attachment,users: recieverList,name: filename};
      return this.http.post(`${this.url}/users/sendEmailToUser`,filedata);
    }
    index++;
  }

  deleteCrewMember(Id: any){
    console.log('for del',Id);
    let _id = Id;
    let para = {activeStatus: 'false'};
    return this.http.patch(`${this.url}/users/${_id}`,para);
  }

  getCrewMemberById(crewId: any) {
    console.log('crew in service ',crewId);
    return this.http.get(`${this.url}/users/byCrewid/${crewId}`);
  }

  getCrewMemberByCrewName(crewName){
    return this.http.get(`${this.url}/users/byCrewName/${crewName}`);
  }

  

  getCrewMemberdataById(Id: any){
    console.log('crew in service ',Id);
    return this.http.get(`${this.url}/users/${Id}`);
  }

  getDepartmentCatRank(){
    return this.http.get(`${this.url}/departments`);
  }

  getCrewMemberByEmail(email: any){
    console.log('for del',email);
    return this.http.get(`${this.url}/admin/getUserProfileByEmail`, email);
  }


  getCrewDataByRole(crewRole: any){
    return this.http.get(`${this.url}/admin/getUsersListByRole`,crewRole);
  }

  addBulkCrewData(crewData: any){
    return this.http.post(`${this.url}/admin/addBulkUsers`, crewData);
  }

  
  updateCrewMember(crewData: any){
    console.log('update ',crewData);
    return this.http.patch(`${this.url}/users/${crewData._id}`,crewData);
  }

  updateCrewMemberPassword(crewData: any){
    console.log('update ',crewData);
    return this.http.patch(APIsEndPoints.CHANGE_PASSWORD, crewData);
  }

  getListFirms(){
    return this.http.get(`${this.url_v2}/ratings/listFirms`);
  }

  sortCrews(crews){
    console.log('crews in service',crews);
    const s = firstBy('rankOrder').thenBy('firstName');
    crews.sort(s);
    return crews;
  }

  getDepartments() {
    return ['Deck', 'Engine', 'Galley'];
  }


  getCategories() {
    return [
      'Senior Officer',
      'Junior Officer',
      'Trainee Officer',
      'Petty Officer',
      'Engine Crew',
      'Deck Crew',
      'Galley Crew'
    ];
  }

  getRanks() {
    return [
      'Master',
      'Chief Officer',
      'Second Officer',
      'Third Officer',
      'Trainee Officer',
      'Deck Cadet',
      'Chief Engineer',
      'Second Engineer',
      'Third Engineer',
      'Fourth Engineer',
      'Fifth Engineer',
      'Electrical Training Officer',
      'Electrician',
      'Engine Cadet',
      'Pump Man',
      'Bosun',
      'Able Seaman',
      'Ordinary Seaman',
      'Fitter',
      'Motorman',
      'Chief Cook'
  ];

  }

  getCounteries(){
    
    return [
      "Afghanistan",
      "Albania",
      "Algeria",
      "American Samoa",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antarctica",
      "Antigua and Barbuda",
      "Argentina",
      "Armenia",
      "Aruba",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas (the)",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia (Plurinational State of)",
      "Bonaire, Sint Eustatius and Saba",
      "Bosnia and Herzegovina",
      "Botswana",
      "Bouvet Island",
      "Brazil",
      "British Indian Ocean Territory (the)",
      "Brunei Darussalam",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cabo Verde",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Cayman Islands (the)",
      "Central African Republic (the)",
      "Chad",
      "Chile",
      "China",
      "Christmas Island",
      "Cocos (Keeling) Islands (the)",
      "Colombia",
      "Comoros (the)",
      "Congo (the Democratic Republic of the)",
      "Congo (the)",
      "Cook Islands (the)",
      "Costa Rica",
      "Croatia",
      "Cuba",
      "Curaçao",
      "Cyprus",
      "Czechia",
      "Côte d'Ivoire",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic (the)",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Eritrea",
      "Estonia",
      "Eswatini",
      "Ethiopia",
      "Falkland Islands (the) [Malvinas]",
      "Faroe Islands (the)",
      "Fiji",
      "Finland",
      "France",
      "French Guiana",
      "French Polynesia",
      "French Southern Territories (the)",
      "Gabon",
      "Gambia (the)",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Grenada",
      "Guadeloupe",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea-Bissau",
      "Guyana",
      "Haiti",
      "Heard Island and McDonald Islands",
      "Holy See (the)",
      "Honduras",
      "Hong Kong",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran (Islamic Republic of)",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "Korea (the Democratic People's Republic of)",
      "Korea (the Republic of)",
      "Kuwait",
      "Kyrgyzstan",
      "Lao People's Democratic Republic (the)",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Macao",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Marshall Islands (the)",
      "Martinique",
      "Mauritania",
      "Mauritius",
      "Mayotte",
      "Mexico",
      "Micronesia (Federated States of)",
      "Moldova (the Republic of)",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands (the)",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger (the)",
      "Nigeria",
      "Niue",
      "Norfolk Island",
      "Northern Mariana Islands (the)",
      "Norway",
      "Oman",
      "Pakistan",
      "Palau",
      "Palestine, State of",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines (the)",
      "Pitcairn",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Republic of North Macedonia",
      "Romania",
      "Russian Federation (the)",
      "Rwanda",
      "Réunion",
      "Saint Barthélemy",
      "Saint Helena, Ascension and Tristan da Cunha",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Martin (French part)",
      "Saint Pierre and Miquelon",
      "Saint Vincent and the Grenadines",
      "Samoa",
      "San Marino",
      "Sao Tome and Principe",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Sint Maarten (Dutch part)",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Georgia and the South Sandwich Islands",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan (the)",
      "Suriname",
      "Svalbard and Jan Mayen",
      "Sweden",
      "Switzerland",
      "Syrian Arab Republic",
      "Taiwan (Province of China)",
      "Tajikistan",
      "Tanzania, United Republic of",
      "Thailand",
      "Timor-Leste",
      "Togo",
      "Tokelau",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks and Caicos Islands (the)",
      "Tuvalu",
      "Uganda",
      "Ukraine",
      "United Arab Emirates (the)",
      "United Kingdom of Great Britain and Northern Ireland (the)",
      "United States Minor Outlying Islands (the)",
      "United States of America (the)",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Venezuela (Bolivarian Republic of)",
      "Viet Nam",
      "Virgin Islands (British)",
      "Virgin Islands (U.S.)",
      "Wallis and Futuna",
      "Western Sahara",
      "Yemen",
      "Zambia",
      "Zimbabwe",
      "Åland Islands"
    ];
    
  }
  
}
